import { createSelector,createSlice } from '@reduxjs/toolkit';
import { defaultFiltersWithStatus } from 'common/types/FiltersWithStatus';
import { getReducers, statusesList } from 'common/utils/statusHelpers';

import type { RootState } from '../../app/store';

const initialState = defaultFiltersWithStatus;

const userGroupsUsersSlice = createSlice({
    name: 'userGroupsUsers',
    initialState,
    reducers: getReducers()
});

// eslint-disable-next-line no-restricted-syntax
export default userGroupsUsersSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, checkStatusFilter } = userGroupsUsersSlice.actions;
export const selectFilters = (state: RootState) => state.userGroupsUsers.filters;

// Memoized selector to prevent unnecessary rerenders
const selectStatusKeys = (state: RootState) => state.userGroupsUsers.filters.dropdowns.status.keys;

export const selectFilteredStatus = createSelector(
    [selectStatusKeys],
    (statusKeys) => statusesList.filter(statusName => statusKeys.includes(statusName))
);
